<template>
  <div class="profile-details-container">
    <div class="d-flex align-center mb-8">
      <v-icon color="#3EA56E" class="mr-3">mdi-account-details-outline</v-icon>
      <h2 class="section-title">Personal Information</h2>
    </div>

    <v-row>
      <v-col cols="12" sm="6" md="4" class="mb-6">
        <div class="info-field">
          <label class="field-label">First Name</label>
          <div class="field-value">{{ appUser.firstname || '-' }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="mb-6">
        <div class="info-field">
          <label class="field-label">Last Name</label>
          <div class="field-value">{{ appUser.lastname || '-' }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="mb-6">
        <div class="info-field">
          <label class="field-label">Email Address</label>
          <div class="field-value">{{ appUser.email || '-' }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="mb-6">
        <div class="info-field">
          <label class="field-label">Mobile Number</label>
          <div class="field-value">+91 {{ appUser.phone || '-' }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="mb-6" v-if="appUser.gender">
        <div class="info-field">
          <label class="field-label">Gender</label>
          <div class="field-value">{{ appUser.gender }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="mb-6" v-if="appUser.dob">
        <div class="info-field">
          <label class="field-label">Date of Birth</label>
          <div class="field-value">{{ formatDate(appUser.dob) }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" class="mb-6" v-if="appUser.locationname">
        <div class="info-field">
          <label class="field-label">Location</label>
          <div class="field-value">{{ appUser.locationname }}</div>
        </div>
      </v-col>
    </v-row>
    
    <div class="mt-8 pt-8 border-top" v-if="$route.path !== '/Profile/Edit'">
       <p class="helper-text">To update your information, please use the "Edit Profile" button above.</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  mounted() {
    this.setMetaTags();
  },
  methods: {
    setMetaTags() {
      document.title = "My Profile | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "View and edit your personal information and profile details at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    formatDate(item) {
      if (!item) return '-';
      const dt = new Date(item);
      const day = dt.getDate();
      const month = dt.toLocaleString('default', { month: 'short' });
      const year = dt.getFullYear();
      return `${day} ${month} ${year}`;
    },
  },
};
</script>

<style scoped>
.profile-details-container {
  text-align: left;
}

.section-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.info-field {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-family: "ibmsemibold", sans-serif;
  font-size: 13px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.field-value {
  font-family: "ibmregular", sans-serif;
  font-size: 16px;
  color: #1e293b;
  line-height: 1.5;
}

.helper-text {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
  color: #64748b;
  font-style: italic;
}

.border-top {
  border-top: 1px solid #f1f5f9;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 18px;
  }
}
</style>